const vue = require('vue');
const constructor = typeof vue === "function" ? vue : vue.default;

module.exports.bus = new constructor();

module.exports.events = {
    backendApiThrottle: 'backendApiThrottle',
    invalidUserSession: 'invalidUserSession',
};